/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _title_fr = new IntlMessageFormat([{ type: 0, value: 'Édition du profil' }], 'fr');

export function title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title_fr.format(args) as unknown as string;
    }

    return _title_fr.format(args) as unknown as string;
}

const _edited_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vos modifications ont été enregistrées.' }],
    'fr',
);

export function edited(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _edited_fr.format(args) as unknown as string;
    }

    return _edited_fr.format(args) as unknown as string;
}

const _menu__sronly_toggle_menu_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ouvrir/Fermer le menu' }],
    'fr',
);

export function menu__sronly_toggle_menu(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__sronly_toggle_menu_fr.format(args) as unknown as string;
    }

    return _menu__sronly_toggle_menu_fr.format(args) as unknown as string;
}

const _menu__coordinates_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Coordonnées' }],
    'fr',
);

export function menu__coordinates(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__coordinates_fr.format(args) as unknown as string;
    }

    return _menu__coordinates_fr.format(args) as unknown as string;
}

const _menu__experiences_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Expériences' }],
    'fr',
);

export function menu__experiences(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__experiences_fr.format(args) as unknown as string;
    }

    return _menu__experiences_fr.format(args) as unknown as string;
}

const _menu__formations_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Formations' }],
    'fr',
);

export function menu__formations(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__formations_fr.format(args) as unknown as string;
    }

    return _menu__formations_fr.format(args) as unknown as string;
}

const _menu__resumes_fr = new IntlMessageFormat([{ type: 0, value: 'CV' }], 'fr');

export function menu__resumes(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__resumes_fr.format(args) as unknown as string;
    }

    return _menu__resumes_fr.format(args) as unknown as string;
}

const _menu__photos_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Photos de profil' }],
    'fr',
);

export function menu__photos(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__photos_fr.format(args) as unknown as string;
    }

    return _menu__photos_fr.format(args) as unknown as string;
}

const _menu__languages_fr = new IntlMessageFormat([{ type: 0, value: 'Langues' }], 'fr');

export function menu__languages(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__languages_fr.format(args) as unknown as string;
    }

    return _menu__languages_fr.format(args) as unknown as string;
}

const _menu__interests_fr = new IntlMessageFormat(
    [{ type: 0, value: "Centres d'intérêts" }],
    'fr',
);

export function menu__interests(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__interests_fr.format(args) as unknown as string;
    }

    return _menu__interests_fr.format(args) as unknown as string;
}

const _menu__mail_fr = new IntlMessageFormat([{ type: 0, value: 'Email' }], 'fr');

export function menu__mail(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__mail_fr.format(args) as unknown as string;
    }

    return _menu__mail_fr.format(args) as unknown as string;
}

const _menu__password_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mot de passe' }],
    'fr',
);

export function menu__password(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__password_fr.format(args) as unknown as string;
    }

    return _menu__password_fr.format(args) as unknown as string;
}

const _menu__pro_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Informations pros' }],
    'fr',
);

export function menu__pro(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__pro_fr.format(args) as unknown as string;
    }

    return _menu__pro_fr.format(args) as unknown as string;
}

const _menu__portfolio_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Portfolio' }],
    'fr',
);

export function menu__portfolio(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__portfolio_fr.format(args) as unknown as string;
    }

    return _menu__portfolio_fr.format(args) as unknown as string;
}

const _menu__notification_settings_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Gestion des notifications' }],
    'fr',
);

export function menu__notification_settings(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__notification_settings_fr.format(args) as unknown as string;
    }

    return _menu__notification_settings_fr.format(args) as unknown as string;
}

const _notification_settings__title_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Choisissez les notifications que vous souhaitez recevoir par mail de notre part :',
        },
    ],
    'fr',
);

export function notification_settings__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _notification_settings__title_fr.format(args) as unknown as string;
    }

    return _notification_settings__title_fr.format(args) as unknown as string;
}

const _notification_settings__label_goafrica_information_mail_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mails d’information de Go Africa' }],
    'fr',
);

export function notification_settings__label_goafrica_information_mail(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _notification_settings__label_goafrica_information_mail_fr.format(
            args,
        ) as unknown as string;
    }

    return _notification_settings__label_goafrica_information_mail_fr.format(
        args,
    ) as unknown as string;
}

const _notification_settings__desc_goafrica_information_mail_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Nous informons régulièrement nos membres par mail, sur nos fonctionnalités et leur intérêt pour votre carrière ou votre entreprise.',
        },
    ],
    'fr',
);

export function notification_settings__desc_goafrica_information_mail(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _notification_settings__desc_goafrica_information_mail_fr.format(
            args,
        ) as unknown as string;
    }

    return _notification_settings__desc_goafrica_information_mail_fr.format(
        args,
    ) as unknown as string;
}

const _notification_settings__label_mail_on_inbox_message_received_fr =
    new IntlMessageFormat([{ type: 0, value: 'Messages reçus' }], 'fr');

export function notification_settings__label_mail_on_inbox_message_received(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _notification_settings__label_mail_on_inbox_message_received_fr.format(
            args,
        ) as unknown as string;
    }

    return _notification_settings__label_mail_on_inbox_message_received_fr.format(
        args,
    ) as unknown as string;
}

const _notification_settings__desc_mail_on_inbox_message_received_fr =
    new IntlMessageFormat(
        [
            {
                type: 0,
                value: 'Lors qu’un membre ou une entreprise vous a écrit un message privé, si vous ne le lisez pas dans les 5 minutes, nous vous envoyons un email de notification, avec le lien vers la lecture de ce message.',
            },
        ],
        'fr',
    );

export function notification_settings__desc_mail_on_inbox_message_received(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _notification_settings__desc_mail_on_inbox_message_received_fr.format(
            args,
        ) as unknown as string;
    }

    return _notification_settings__desc_mail_on_inbox_message_received_fr.format(
        args,
    ) as unknown as string;
}

const _notification_settings__label_mail_on_network_interaction_fr =
    new IntlMessageFormat(
        [{ type: 0, value: 'Interaction sur le réseau social (like, partage…)' }],
        'fr',
    );

export function notification_settings__label_mail_on_network_interaction(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _notification_settings__label_mail_on_network_interaction_fr.format(
            args,
        ) as unknown as string;
    }

    return _notification_settings__label_mail_on_network_interaction_fr.format(
        args,
    ) as unknown as string;
}

const _notification_settings__desc_mail_on_network_interaction_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Lorsque vous recevez des likes, commentaires, réponses, partages… sur le réseau social professionnel Go Africa Online, nous pouvons vous notifier par mail pour que vous puissiez être réactif avec votre communauté.',
        },
    ],
    'fr',
);

export function notification_settings__desc_mail_on_network_interaction(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _notification_settings__desc_mail_on_network_interaction_fr.format(
            args,
        ) as unknown as string;
    }

    return _notification_settings__desc_mail_on_network_interaction_fr.format(
        args,
    ) as unknown as string;
}
